import { GridColumnType } from '@grid'
import { BoxType } from '@schemas'

const numberCol = (field: string, headerName: string, digits: number) => ({
	field,
	headerName,
	headerAlign: 'center' as const,
	align: 'right' as const,
	type: 'number' as const,
	width: 110,
	editable: true,
	valueFormatter: (value: number) =>
		value === null || value === undefined ? '' : Number(value).toFixed(digits),
})

/** 박스 규격 (`/main/box` 위 밴드). 인라인 편집. */
export const boxColumns: GridColumnType = {
	initRow: {
		code: '',
		name: '',
		widthCm: 0,
		heightCm: 0,
		depthCm: 0,
		tareKg: 0,
		useYn: 1,
		memo: '',
		productCount: 0,
	},
	fieldToFocus: 'code',
	card: { title: 'code', status: 'useYn', subtitle: 'name' },
	columns: [
		{
			field: 'code',
			headerName: '코드',
			headerAlign: 'center',
			width: 90,
			editable: true,
		},
		{
			field: 'name',
			headerName: '이름',
			headerAlign: 'center',
			width: 200,
			editable: true,
		},
		numberCol('widthCm', '가로(cm)', 1),
		numberCol('heightCm', '세로(cm)', 1),
		numberCol('depthCm', '높이(cm)', 1),
		numberCol('tareKg', '빈 박스(kg)', 2),
		{
			field: 'useYn',
			headerName: '사용',
			headerAlign: 'center',
			align: 'center',
			width: 90,
			editable: true,
			type: 'singleSelect',
			valueOptions: [
				{ value: 1, label: '사용' },
				{ value: 0, label: '중지' },
			],
		},
		{
			field: 'productCount',
			headerName: '연결 제품',
			headerAlign: 'center',
			align: 'right',
			width: 100,
			editable: false,
		},
		{
			field: 'memo',
			headerName: '메모',
			headerAlign: 'center',
			width: 240,
			editable: true,
		},
	],
}

/** 제품 포장 설정 (`/main/box` 아래 밴드). 박스 셀렉트는 현재 박스 목록으로 만든다. */
export const productPackagingColumns = (boxes: BoxType[]): GridColumnType => ({
	initRow: { code: '', name: '', boxId: '', netKg: null },
	fieldToFocus: 'boxId',
	card: { title: 'code', status: 'useYn', subtitle: 'name' },
	columns: [
		{
			field: 'code',
			headerName: '코드',
			headerAlign: 'center',
			width: 100,
			editable: false,
		},
		{
			field: 'name',
			headerName: '제품',
			headerAlign: 'center',
			width: 220,
			editable: false,
		},
		{
			field: 'boxId',
			headerName: '박스',
			headerAlign: 'center',
			width: 220,
			editable: true,
			type: 'singleSelect',
			valueOptions: [
				{ value: '', label: '(없음)' },
				...boxes.map(b => ({
					value: b.id,
					label: `${b.code} · ${b.widthCm}×${b.heightCm}×${b.depthCm}`,
				})),
			],
		},
		{
			field: 'netKg',
			headerName: '제품 무게(kg)',
			headerAlign: 'center',
			align: 'right',
			type: 'number',
			width: 130,
			editable: true,
			valueFormatter: (value: number | null) =>
				value === null || value === undefined ? '' : Number(value).toFixed(2),
		},
		{
			field: 'useYn',
			headerName: '판매',
			headerAlign: 'center',
			align: 'center',
			width: 80,
			editable: false,
			valueFormatter: (value: number) => (Number(value) === 1 ? '판매' : '중지'),
		},
	],
})
